import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { clickAsLink } from 'helpers/link_helpers';

import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';

export default class ContactsImportResults extends React.Component {
  static propTypes = {
    contacts: PropTypes.array.isRequired,
    contactsIndexPath: PropTypes.string.isRequired,
    editUserPath: PropTypes.string,
    isSameUser: PropTypes.bool,
    profileSettingsPath: PropTypes.string.isRequired,
  };

  handleBackToPage = (e, path) => clickAsLink(window, path, e);

  importMetrics = () => {
    const { contacts } = this.props;
    let successCount = 0;
    let errorCount = 0;
    contacts.forEach((contact) => {
      if (contact.status === "not_imported" || contact.status === "already_imported") {
        errorCount++;
      } else {
        successCount++;
      }
    });

    return { successCount, errorCount };
  }

  setStatus = (status) => {
    let statusClass, statusText;

    switch (status) {
    case "warning":
      statusClass = classNames({ "text-yellow": true });
      statusText = "Warning";
      break;
    case "success":
      statusClass = classNames({ "text-success": true });
      statusText = "Successful";
      break;
    default:
      statusClass = classNames({ "text-muted": true });
      statusText = "Not Imported";
    }

    return { statusClass, statusText };
  }

  render() {
    const { successCount, errorCount } = this.importMetrics();

    return (
      <div className="container">
        <div className="page-header">
          <h5 className="mb-2">
            Contacts Imported
          </h5>
          <p>
            {successCount} successfully imported.
            {errorCount > 0 && " " + errorCount + " contacts unsuccessfully imported"}
          </p>
        </div>
        <div className="container merge-container bg-card border-top-0 p-4">
          <p>
            Import Results
          </p>
          {this.renderResultsTable()}
        </div>
      </div>
    );
  }

  renderResultsTable() {
    const { contactsIndexPath, profileSettingsPath, editUserPath, isSameUser } = this.props;
    const backRoute = isSameUser ? profileSettingsPath : editUserPath;

    return (
      <div>
        <Table className="align-middle">
          <thead>
            {this.renderHeaderColumns()}
          </thead>
          <tbody>
            {this.renderTableContent()}
          </tbody>
        </Table>
        <div className="d-flex justify-content-end gap-3 mt-3">
          <Button.Secondary label="Back To Integrations" onClick={e => this.handleBackToPage(e, backRoute)} />
          <Button.Primary
            label="View Contacts"
            onClick={e => this.handleBackToPage(e, contactsIndexPath)}
          />
        </div>
      </div>
    );
  }

  renderHeaderColumns() {
    return (
      <tr key="headers">
        <th className="fw-semibold">Status</th>
        <th className="fw-semibold">Name</th>
        <th className="fw-semibold">Email</th>
        <th className="fw-semibold">Report</th>
      </tr>
    );
  }

  renderTableContent() {
    const rows = [];
    const { contacts } = this.props;

    contacts.map((contact) => {
      const { statusClass, statusText } = this.setStatus(contact.status);

      const warningToolTip = (<Tooltip id={contact.id}>
        This email address was already associated with a Contact in your Database.
        If you want to combine contact information information, you can merge mulitiple contacts after the import.
      </Tooltip>);

      rows.push(
        <tr key={contact.id}>
          <td className={statusClass}>{statusText}</td>
          <td>{contact.name}</td>
          <td>{contact.email}</td>
          <td className={contact.status === "warning" ? "text-yellow" : ""}>
            {contact.status === "warning" &&
              <OverlayTrigger overlay={warningToolTip} placement="top">
                <FontAwesomeIcon className="me-2" icon={faInfoCircle} />
              </OverlayTrigger>
            }
            {contact.report}
          </td>
        </tr>
      );
    });
    return rows;
  }
}
